import type { AssignmentStatus } from '@dubforge/shared';

/**
 * Design tokens: the one place to restyle DubForge.
 *
 * Change a colour, font or radius here and every screen follows. theme.ts turns these into the MUI
 * theme (including light and dark palettes), and components only ever read colours from the theme.
 */
export const tokens = {
  font: {
    family: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    headingWeight: 700,
  },
  radius: 12,
  /** Base spacing unit in px (MUI multiplies this, e.g. sx={{ p: 2 }} = 16px). */
  spacing: 8,

  brand: {
    primary: '#7c5cff',
    secondary: '#ff5c8a',
    discord: '#5865f2',
  },

  light: {
    background: '#f6f5fb',
    surface: '#ffffff',
    border: '#e4e2ee',
    text: '#1b1a23',
    textMuted: '#5f5d70',
  },

  dark: {
    background: '#111017',
    surface: '#1b1a24',
    border: '#2e2c3b',
    text: '#eeecf6',
    textMuted: '#a6a3b8',
  },

  feedback: {
    success: '#22a06b',
    warning: '#e2a03f',
    error: '#e5484d',
    info: '#3e8ef7',
  },
} as const;

/** Colour for each assignment status, used by StatusChip and the status board. Labels are in i18n. */
export const statusColors: Record<
  AssignmentStatus,
  'default' | 'info' | 'warning' | 'primary' | 'error' | 'success'
> = {
  Assigned: 'default',
  InProgress: 'info',
  Submitted: 'warning',
  ChangesRequested: 'error',
  Approved: 'success',
};
